import type { CountryCode } from 'src/constants';
import { getIsEmailValid, getIsPhoneValid, getIsYearValid } from 'src/utils';
import type { IClientInfo, IForm } from 'src/interfaces';

export const mapFormFieldsToInfo = (formFields: IForm): IClientInfo => ({
  countryCode: formFields.countryCode.value as CountryCode,
  email: getIsEmailValid(formFields.email.value) ? formFields.email.value.trim() : '',
  lastName: formFields.lastName.value.trim(),
  firstName: formFields.firstName.value.trim(),
  phone: getIsPhoneValid(formFields.phone.value) ? formFields.phone.value.trim() : '',
  message: formFields.message.value.trim(),

  cemetery: formFields.cemetery.value.trim(),
  decedent: formFields.decedent.value.trim(),
  yearOfBirth: getIsYearValid(formFields.yearOfBirth.value)
    ? formFields.yearOfBirth.value.trim()
    : '',
  yearOfDeath: getIsYearValid(formFields.yearOfDeath.value)
    ? formFields.yearOfDeath.value.trim()
    : '',
});
